module.exports = __webpack_public_path__ + "static/np_user_197694_000000-26db0f2db3cabff02a9a1f4eed1d9f71.png";